// export const BACKEND_URL = 'https://integracao-santacasasjc.insightcare.com.br';
// export const BACKEND_INS_URL = 'https://api-santacasasjc.insightcare.com.br';
// export const BACKEND_URL = 'https://integracao-igesp.insightcare.com.br';
// export const BACKEND_INS_URL = 'https://api-igesp.insightcare.com.br';
// export const BACKEND_URL = 'https://integracao-hsh.insightcare.com.br';
// export const BACKEND_INS_URL = 'https://api-hsh.insightcare.com.br';
// export const BACKEND_URL = 'https://integracao-amaralcarvalho.insightcare.com.br';
// export const BACKEND_INS_URL = 'https://api-amaralcarvalho.insightcare.com.br';
export const BACKEND_URL = 'https://integracao-aebel.insightcare.com.br';
export const BACKEND_INS_URL = 'https://api-aebel.insightcare.com.br';
// export const BACKEND_URL = 'https://integracao.gruposanta.com.br';
// export const BACKEND_INS_URL = 'https://api-gruposanta.insightcare.com.br';